import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getGlobalFilterOptions: builder.query({
      query: (body = {}) => ({
        url: '/api/meta/filters',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useLazyGetGlobalFilterOptionsQuery, useGetGlobalFilterOptionsQuery } = extendedApi
